import { call, put, select, takeLatest } from 'redux-saga/effects'
import {
  setFallsurfaceOptions,
  setInjurycauseOptions,
  setIntentionalOptions,
  setLandedonOptions,
  setMechanismOptions,
  setSafetyEquipmentOptions,
  setTraumaTriageCriteriaModerateRiskOptions,
  setTraumatriageCriteriaHighRiskOptions,
  setWorkrelatedOptions,
} from '../store/options.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { OptionsService } from '../services/options.service'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getInjuryDetailsOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const intentionalOptionsResponse: IOptionsResponse = yield call([
      optionsService,
      optionsService.getIntentionalOptions,
    ])
    yield put(setIntentionalOptions(intentionalOptionsResponse.entity))

    const traumaTriageCriteriaHighRiskResponse: IOptionsResponse = yield call([
      optionsService,
      optionsService.getTraumatriageCriteriaHighRiskOptions,
    ])
    yield put(setTraumatriageCriteriaHighRiskOptions(traumaTriageCriteriaHighRiskResponse.entity))

    const traumaTriageCriteriaModerateRiskResponse: IOptionsResponse = yield call([
      optionsService,
      optionsService.getTraumaTriageCriteriaModerateRiskOptions,
    ])
    yield put(setTraumaTriageCriteriaModerateRiskOptions(traumaTriageCriteriaModerateRiskResponse.entity))

    const injurycauseOptionsResponse: IOptionsResponse = yield call([
      optionsService,
      optionsService.getInjurycauseOptions,
    ])
    yield put(setInjurycauseOptions(injurycauseOptionsResponse.entity))

    const mechanismOptionsResponse: IOptionsResponse = yield call([optionsService, optionsService.getMechanismOptions])
    yield put(setMechanismOptions(mechanismOptionsResponse.entity))

    const safetyEquipmentOptionsResponse: IOptionsResponse = yield call([
      optionsService,
      optionsService.getSafetyEquipmentOptions,
    ])
    yield put(setSafetyEquipmentOptions(safetyEquipmentOptionsResponse.entity))

    const fallsurfaceOptionsResponse: IOptionsResponse = yield call([
      optionsService,
      optionsService.getFallsurfaceOptions,
    ])
    yield put(setFallsurfaceOptions(fallsurfaceOptionsResponse.entity))

    const landedonOptionsResponse: IOptionsResponse = yield call([optionsService, optionsService.getLandedonOptions])
    yield put(setLandedonOptions(landedonOptionsResponse.entity))

    const workrelatedOptionsResponse: IOptionsResponse = yield call([
      optionsService,
      optionsService.getWorkrelatedOptions,
    ])
    yield put(setWorkrelatedOptions(workrelatedOptionsResponse.entity))
  } catch (e) {
    yield put(throwPcrException(`getInjuryDetailsOptions() error: ${e}`))
  }
}
export function* getInjuryDetailsOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getInjuryDetailsOptions)
}
